
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Définition complète et approfondie d'un Showroom : Tout ce que vous devez savoir",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez la définition précise de showroom, un concept clé dans le monde de la vente et du design. Informez-vous et apprenez-en plus sur ce terme crucial.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Définition complète et approfondie d'un Showroom : Tout ce que vous devez savoir",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez la définition précise de showroom, un concept clé dans le monde de la vente et du design. Informez-vous et apprenez-en plus sur ce terme crucial.",
        },
      ],
    };
  },
};
